import { Container, Mute, Slider, VolumeRange } from '@studio/design-system/audio/volume';
import { middle } from '@studio/js-utils/range';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Props } from './types.js';
import { useMutedPref, useVolumePref } from '#~/audio/hooks.js';

/** `<Volume>` component. */
export const Volume = (props: Props): ReactElement => {
  const [volume, setVolume] = useVolumePref();
  const [muted, setMuted] = useMutedPref();

  const handleVolumeChange = useLatestFn((nextVolume: number): void => {
    setVolume(nextVolume);

    if (nextVolume > VolumeRange.min) {
      setMuted(false);
    }
  });

  const handleMuteChange = useLatestFn((nextMuted: boolean): void => {
    setMuted(nextMuted);

    if (!nextMuted && volume === 0) {
      handleVolumeChange(middle(VolumeRange));
    }
  });

  return (
    <Container {...props}>
      <Mute muted={muted} onChange={handleMuteChange} />
      <Slider onChange={handleVolumeChange} value={muted ? 0 : volume} />
    </Container>
  );
};
